/* CATEGORIES ID */
export const FRUIT_CATEGORY_ID: string = 'zpfBvWe7A6NYXF6gZ';
export const COFFEE_CATEGORY_ID: string = 'DxDpLm7gFZxBT3d4B';
export const TOTEM_INSTALLATION_CATEGORY_ID: string = 'QY4qSgsjwuYYBAEeh';
export const BEER_CATEGORY_ID: string = 'DPogLHpv8CfAnheZ2';
export const BEER_EQUIPMENT_CATEGORY_ID: string = '7CpWgSsvLrC5pgqDE';
export const INDIVIDUAL_SNACKS_CATEGORY_ID: string = 'rT9FzJZAJQ6pe83t5';
export const SNACKS_IN_BULK_CATEGORY_ID: string = 'X5A978gGcnXzFfphi';
export const COLD_DRINKS_CATEGORY_ID: string = 'hRp2WC7tCSEE6DT7R';
export const DESSERTS_CATEGORY_ID: string = 'pPNNmDyijRkhyBq6n';
export const MEALS_CATEGORY_ID: string = 'HNJaaoCKYQvr5B5W8';
export const STARTERS_CATEGORY_ID: string = 'yatqdfxAyKEuuF7vK';
export const BAKERY_CATEGORY_ID: string = 'xcsRXJ4Jd8jpoXyo3';

export const DEFAULT_CATEGORY_ID: string = FRUIT_CATEGORY_ID;

export const MEAL_CATEGORIES: string[] = [MEALS_CATEGORY_ID, STARTERS_CATEGORY_ID];
